import App from "@fae/source/models/App.js"
import Dev from "@fae/source/models/dev/Dev.js"
import Geometry from "@fae/source/utility/Geometry.js"

import {tileset} from "@fae/source/data/tilesets.js"
const BLOCK_SIZE = 1

import Keyb from "keyb"
import Poin from "poin"
import {nanoid} from "nanoid"
import Objdict from "objdict"

export default class DevSelection {
    constructor() {
        this.z = 1
        this.drag = {}

        this.multiselectedVertexKeys = []
    }
    // === Regular Loop Updates === //
    update() {
        if(Dev.inProtoMode == false) return
        if(Keyb.wasJustPressed("T")) {
            this.z += 1
        }
        if(Keyb.wasJustPressed("G")) {
            this.z = 1
        }
        if(Keyb.wasJustPressed("B")) {
            this.z -= 1
        }

        const selection = App.game.chapter.selection
        const hoveredSpot = Object.values(Dev.loadedProtostage.world.spots).find((spot) => {
            return spot.position.x == selection.position.x
                && spot.position.y == selection.position.y
        })
        if(hoveredSpot != undefined) {
            this.hoveredSpotKey = hoveredSpot.key
        } else {
            this.hoveredSpotKey = undefined
        }

        let hoveredEncounter = Object.values(Dev.loadedProtostage.world.encounters).find((encounter) => {
            return encounter.points.find((vertex) => {
                return vertex.x == selection.position.x + 0.5
                        && vertex.y == selection.position.y + 0.5
            })
        }) || Object.values(Dev.loadedProtostage.world.encounters).find((encounter) => {
            return Geometry.isInBounds(encounter, selection.position)
        })
        if(hoveredEncounter != undefined) {
            this.hoveredEncounterKey = hoveredEncounter.key
        } else {
            this.hoveredEncounterKey = undefined
        }

        const hoveredVertex = hoveredEncounter?.points.find((vertex) => {
            return vertex.x == selection.position.x + 0.5
                && vertex.y == selection.position.y + 0.5
        })
        if(hoveredVertex != undefined) {
            this.hoveredVertexKey = hoveredVertex.key
        } else {
            this.hoveredVertexKey = undefined
        }

        const hoveredTileKey = Math.ceil(App.game.chapter.selection.position.x) + "x" + Math.ceil(App.game.chapter.selection.position.y) + "x" + (this.z - BLOCK_SIZE)
        this.hoveredBlockKeys = Object.keys(Dev.loadedProtostage.world.blocks).filter((key) => key.startsWith(hoveredTileKey))

        if(this.drag.targets != undefined) {
            const position = {
                "x": Math.ceil(selection.position.x),
                "y": Math.ceil(selection.position.y),
                "z": this.z,
            }
            if(Dev.mode == "battle") {
                if(this.drag.targets.unit != undefined) Dev.loadedProtostage.units[this.drag.targets.unit].position = position
                if(this.drag.targets.spot != undefined) Dev.loadedProtostage.world.spots[this.drag.targets.spot].position = position
            }
            if(Dev.mode == "geography") {
                if(this.drag.targets.encounter != undefined
                && this.drag.targets.vertices != undefined) {
                    this.drag.targets.vertices.forEach((vertex) => {
                        const point = Dev.loadedProtostage.world.encounters[this.drag.targets.encounter].points.find((point) => point.key == vertex)
                        const startPoint = this.drag.startStage.encounters[this.drag.targets.encounter].points.find((point) => point.key == vertex)
                        point.x = startPoint.x + (position.x - this.drag.startPosition.x)
                        point.y = startPoint.y + (position.y - this.drag.startPosition.y)
                        point.z = startPoint.z + (position.z - this.drag.startPosition.z)
                    })
                }
            }
        }
        if(this.drag.startPosition != undefined) {
            /* --- Camera pan --- */
            if(Poin.isPressed("auxiliary")) {
                selection.camera.position.x = this.drag.startPosition.x - selection.pointer.position.x * selection.camera.position.z
                selection.camera.position.y = this.drag.startPosition.y - selection.pointer.position.y * selection.camera.position.z
            }
        }
    }
    start() {
        if(Dev.inProtoMode == false) return
        this.drag = {}
        this.drag.startPosition = {
            "x": Math.ceil(App.game.chapter.selection.position.x),
            "y": Math.ceil(App.game.chapter.selection.position.y),
            "z": this.z,
        }
        if((App.game.chapter.selection.hoveredUnitKey != undefined
        || this.hoveredSpotKey != undefined
        || this.hoveredEncounterKey != undefined
        || this.hoveredVertexKey != undefined
        || this.multiselectedVertexKeys.length > 0)
        && Dev.selectedTemplate == undefined
        && this.selectedTileTemplate == undefined
        && this.selectedSpotTemplate == undefined
        && this.selectedEncounterAsset == undefined) {
            Dev.saveToUndo()
            this.drag.targets = {}
            if(Dev.mode == "battle") {
                this.drag.targets.unit = App.game.chapter.selection.hoveredUnitKey
                this.drag.targets.spot = this.hoveredSpotKey
            }
            this.drag.startStage = structuredClone({
                "encounters": Dev.loadedProtostage.world.encounters,
            })
            if(Dev.mode == "geography") {
                this.drag.targets.encounter = this.hoveredEncounterKey
                if(this.selectedEncounterKey == this.hoveredEncounterKey) {
                    if(this.hoveredVertexKey != undefined) this.drag.targets.vertices = [this.hoveredVertexKey]
                    if(this.multiselectedVertexKeys.length > 0) {
                        this.drag.targets.vertices = this.multiselectedVertexKeys
                    }
                }
                if(this.drag.targets.vertices == undefined
                && this.drag.targets.encounter != undefined) {
                    this.drag.targets.vertices = Dev.loadedProtostage.world.encounters[this.drag.targets.encounter].points.map((point) => point.key)
                }
            }
        }

        /* --- Selecting encounters/spots/units --- */
        if(Dev.mode == "battle" || Dev.mode == "scripts") {
            this.clearSelected()
            this.selectedSpotKey = this.hoveredSpotKey
        }
        if(Dev.mode == "geography") {
            const selection = App.game.chapter.selection
            let hoveredEdge = Geometry.findClosestEdgeToPoint({
                "probePoint": {
                    "x": Math.floor(selection.position.x + 0.5),
                    "y": Math.floor(selection.position.y + 0.5),
                },
                "polygons": Dev.loadedProtostage.world.encounters,
                "maximumAcceptedDistance": 1,
            })
            if(this.selectedEncounterKey != undefined) {
                hoveredEdge = Geometry.findClosestEdgeToPoint({
                    "probePoint": {
                        "x": Math.floor(selection.position.x + 0.5),
                        "y": Math.floor(selection.position.y + 0.5),
                    },
                    "polygons": [Dev.loadedProtostage.world.encounters[this.selectedEncounterKey]],
                    "maximumAcceptedDistance": 1,
                }) || hoveredEdge
            }
            let hoveredEdgeDistance = undefined
            if(hoveredEdge != undefined) {
                hoveredEdgeDistance = Geometry.percentageAlongTheEdgeBetweenTwoPoints({
                    "x": Math.floor(selection.position.x + 0.5),
                    "y": Math.floor(selection.position.y + 0.5),
                }, hoveredEdge.pointA, hoveredEdge.pointB)
                const edgeLength = Geometry.distance(hoveredEdge.pointA, hoveredEdge.pointB)
                if(hoveredEdgeDistance < 0.5 || hoveredEdgeDistance > edgeLength - 0.5) hoveredEdge = undefined
            }

            this.selectedSpotKey = undefined
            this.selectedSavestateReport = undefined
            if((hoveredEdge?.encounterKey || this.hoveredEncounterKey) != this.selectedEncounterKey) {
                this.multiselectedVertexKeys = []
                this.selectedVertexKey = undefined
                this.selectedEncounterKey = this.hoveredEncounterKey
            }

            if(Keyb.isPressed("<shift>")) {
                if(hoveredEdge != undefined) {
                    if(this.multiselectedVertexKeys.includes(hoveredEdge.pointA.key)
                    && this.multiselectedVertexKeys.includes(hoveredEdge.pointB.key)) {
                        this.multiselectedVertexKeys.splice(this.multiselectedVertexKeys.indexOf(hoveredEdge.pointA.key), 1)
                        this.multiselectedVertexKeys.splice(this.multiselectedVertexKeys.indexOf(hoveredEdge.pointB.key), 1)
                        if(this.selectedVertexKey == this.hoveredVertexKey) this.selectedVertexKey = undefined
                    } else {
                        this.multiselectedVertexKeys.push(hoveredEdge.pointA.key)
                        this.multiselectedVertexKeys.push(hoveredEdge.pointB.key)
                        if(this.selectedVertexKey != undefined) this.multiselectedVertexKeys.push(this.selectedVertexKey)
                        this.selectedVertexKey = this.hoveredVertexKey
                    }
                    this.selectedEncounterKey = hoveredEdge.encounterKey
                } else {
                    if(this.multiselectedVertexKeys.includes(this.hoveredVertexKey)) {
                        this.multiselectedVertexKeys.splice(this.multiselectedVertexKeys.indexOf(this.hoveredVertexKey), 1)
                        if(this.selectedVertexKey == this.hoveredVertexKey) this.selectedVertexKey = undefined
                    } else {
                        this.multiselectedVertexKeys.push(this.hoveredVertexKey)
                        if(this.selectedVertexKey != undefined) this.multiselectedVertexKeys.push(this.selectedVertexKey)
                        this.selectedVertexKey = this.hoveredVertexKey
                    }
                }
            } else {
                if(this.drag?.targets?.vertices == undefined) this.multiselectedVertexKeys = []
                if(hoveredEdge != undefined) {
                    this.multiselectedVertexKeys.push(hoveredEdge.pointA.key)
                    this.multiselectedVertexKeys.push(hoveredEdge.pointB.key)
                    this.selectedEncounterKey = hoveredEdge.encounterKey
                } else {
                    this.selectedVertexKey = this.hoveredVertexKey
                }
            }

            this.selectedBlockKeys = this.hoveredBlockKeys
        }

        if(Dev.mode == "scripts"
        && this.selectedSceneStep != undefined
        && (Keyb.isDown("<meta>") == true
        || Keyb.isDown("<control>") == true)) {
            const pastedKey = this.hoveredSpotKey || App.game.chapter?.selection?.hoveredUnitKey || (App.game?.chapter?.selection?.position?.x || 0) + "x" + (App.game?.chapter?.selection?.position?.y || 0)
            if(pastedKey != undefined) {
                this.selectedSceneStep.body = this.selectedSceneStep.body + " " + pastedKey
            }
        }
    }
    finish() {
        if(Dev.inProtoMode == false) return

        /* --- Adding new encounters/spots/units --- */

        const selection = App.game.chapter.selection
        if(Dev.mode == "battle"
        || Dev.mode == "scripts") {
            if(Dev.selectedTemplate != undefined) {
                this.placeNewUnit(selection.position)
                if(Dev.selectedTemplate.templateKey.startsWith("player/")) {
                    Dev.selectedTemplate = undefined
                }
            }
            if(this.selectedSpotTemplate != undefined) {
                Dev.saveToUndo()
                const newKey = nanoid().slice(0,5)
                const baseSpot = {
                    "position": {
                        "x": selection.position.x,
                        "y": selection.position.y,
                        "z": 1,
                    },
                    "key": newKey,
                }
                const newSpot = Objdict.merge(baseSpot, this.selectedSpotTemplate)
                Dev.loadedProtostage.world.spots[newKey] = newSpot

                if(this.selectedSpotTemplate.tag == "path"
                && this.selectedSceneStep?.body != undefined) {
                    this.selectedSceneStep.body = this.selectedSceneStep.body + " " + newKey
                    //Dev.reparseScript()
                }

                return
            }
        } else if(Dev.mode == "geography") {
            const x = Math.ceil(selection.position.x)
            const y = Math.ceil(selection.position.y)
            const z = this.z

            if(this.selectedTileTemplate != undefined) {
                Dev.saveToUndo()
                if(this.drag.startPosition.x != x
                || this.drag.startPosition.y != y) {
                    for(let boxedX = Math.min(x, this.drag.startPosition.x); boxedX <= Math.max(x, this.drag.startPosition.x); boxedX++) {
                        for(let boxedY = Math.min(y, this.drag.startPosition.y); boxedY <= Math.max(y, this.drag.startPosition.y); boxedY++) {
                            this.addTileToBlock({
                                "position": {"x": boxedX, "y": boxedY, "z": z},
                                "tileTemplate": this.selectedTileTemplate
                            })
                        }
                    }
                } else {
                    this.addTileToBlock({
                        "position": {"x": x, "y": y, "z": z},
                        "tileTemplate": this.selectedTileTemplate
                    })
                }
                Dev.redrawWorld()

                return
            }
            if(this.selectedEncounterAsset == "rectangle") {
                Dev.saveToUndo()
                const width = 3 + 3
                const height = 3 + 3
                const stampPoints = [
                    {"x": x, "y": y},
                    {"x": x + width, "y": y},
                    {"x": x + width, "y": y + height},
                    {"x": x, "y": y + height},
                ]

                const encounterKeyNumbers = Object.keys(Dev.loadedProtostage.world.encounters).map((encounterKey) => {
                    if(isNaN(encounterKey)) return 0
                    return +encounterKey
                })
                const newKey = Math.max(...encounterKeyNumbers) + 1

                const newEncounter = {
                    "key": newKey,
                    "zoomout": 1.0,
                    "z": z,
                    "points": stampPoints.map((point) => {
                        return {
                            "x": point.x,
                            "y": point.y,
                            "key": nanoid().slice(0,5),
                        }
                    })
                }
                Dev.loadedProtostage.world.encounters[newKey] = newEncounter
                return
            } else if(this.selectedEncounterAsset == "polygon"
                    && (this.hoveredVertexKey == undefined
                    || this.selectedVertexKey != undefined)) {

                Dev.saveToUndo()
                const newVertex = {
                    "x": Math.floor(selection.position.x + 0.5),
                    "y": Math.floor(selection.position.y + 0.5),
                    "key": nanoid().slice(0,5),
                }
                if(this.selectedEncounterKey != undefined) {
                    if(this.selectedVertexKey != undefined) {
                        const selectedEncounterVertices = Dev.loadedProtostage.world.encounters[this.selectedEncounterKey].points
                        const selectedVertexIndex = selectedEncounterVertices.findIndex((point) => point.key == this.selectedVertexKey)
                        selectedEncounterVertices.splice(selectedVertexIndex + 1, 0, newVertex)
                    } else {
                        Dev.loadedProtostage.world.encounters[this.selectedEncounterKey].points.push(newVertex)
                    }
                    this.hoveredEncounterKey = this.selectedEncounterKey
                } else {
                    const encounterKeyNumbers = Object.keys(Dev.loadedProtostage.world.encounters).map((encounterKey) => {
                        if(isNaN(encounterKey)) return 0
                        return +encounterKey
                    })
                    const newKey = Math.max(...encounterKeyNumbers) + 1
                    const newEncounter = {
                        "key": newKey,
                        "zoomout": 1.0,
                        "z": z,
                        "points": [newVertex]
                    }
                    Dev.loadedProtostage.world.encounters[newKey] = newEncounter
                    this.hoveredEncounterKey = newKey
                }
                this.hoveredVertexKey = newVertex.key
                return
            } else if(this.selectedEncounterAsset == "vertex") {
                Dev.saveToUndo()
                const newVertex = {
                    "x": Math.floor(selection.position.x + 0.5),
                    "y": Math.floor(selection.position.y + 0.5),
                    "key": nanoid().slice(0,5),
                }

                const closestEdge = Geometry.findClosestEdgeToPoint({
                    "probePoint": newVertex,
                    "polygons": Dev.loadedProtostage.world.encounters,
                    "maximumAcceptedDistance": 4,
                })
                if(closestEdge == null) {
                    const newEncounterKey = nanoid().slice(0,5)
                    const newEncounter = {
                        "key": newEncounterKey,
                        "zoomout": 1.0,
                        "z": z,
                        "points": [newVertex]
                    }
                    Dev.loadedProtostage.world.encounters[newEncounterKey] = newEncounter
                    this.hoveredEncounterKey = newEncounterKey
                } else {
                    const closestEncounterVertices = Dev.loadedProtostage.world.encounters[closestEdge.encounterKey].points
                    const closestVertexIndex = closestEncounterVertices.findIndex((point) => point.key == closestEdge.pointB.key)
                    closestEncounterVertices.splice(closestVertexIndex, 0, newVertex)
                    this.hoveredEncounterKey = closestEdge.encounterKey
                }
                return
            }
            this.drag = {}
        }

        /* --- Dragging encounters/spots/units --- */

        if(this.drag.targets != undefined) {
            const position = {
                "x": Math.ceil(selection.position.x),
                "y": Math.ceil(selection.position.y),
                "z": this.z,
            }
            if(Dev.mode == "battle") {
                if(this.drag.targets.unit != undefined) {
                    Dev.loadedProtostage.units[this.drag.targets.unit].position = position
                }
                if(this.drag.targets.spot != undefined) {
                    Dev.loadedProtostage.world.spots[this.drag.targets.spot].position = position
                    this.selectedSpotKey = this.drag.targets.spot
                }
                if(this.drag.targets.unit != undefined
                || this.drag.targets.spot != undefined) {
                    this.drag = {}
                    return
                }
            }
            if(Dev.mode == "geography") {
                if(this.drag.targets.encounter != undefined
                && this.drag.targets.vertices != undefined) {
                    this.drag.targets.vertices.forEach((vertex) => {
                        const point = Dev.loadedProtostage.world.encounters[this.drag.targets.encounter].points.find((point) => point.key == vertex)
                        const startPoint = this.drag.startStage.encounters[this.drag.targets.encounter].points.find((point) => point.key == vertex)
                        point.x = startPoint.x + (position.x - this.drag.startPosition.x)
                        point.y = startPoint.y + (position.y - this.drag.startPosition.y)
                        point.z = startPoint.z + (position.z - this.drag.startPosition.z)
                    })
                    this.drag = {}
                    return
                }
            }
        }

        /* --- Lasso select --- */
        if(this.drag.startPosition != undefined) {
            const lassoedUnitKeys = []
            const dragBoxLeftX = Math.min(this.drag.startPosition.x, selection.position.x)
            const dragBoxRightX = Math.max(this.drag.startPosition.x, selection.position.x)
            const dragBoxTopY = Math.min(this.drag.startPosition.y, selection.position.y)
            const dragBoxBottomY = Math.max(this.drag.startPosition.y, selection.position.y)

            if(Dev.mode == "battle") {
                Object.keys(Dev.loadedProtostage.units).forEach((unitKey) => {
                    const unit = Dev.loadedProtostage.units[unitKey]
                    if(unit.position.x >= dragBoxLeftX
                    && unit.position.x <= dragBoxRightX
                    && unit.position.y >= dragBoxTopY
                    && unit.position.y <= dragBoxBottomY) {
                        lassoedUnitKeys.push(unitKey)
                    }
                })
                if(lassoedUnitKeys.length > 0) selection.select(lassoedUnitKeys)
            }

            this.drag = {}
        }
    }
    wheel(event) {
        const ZOOM_RATE = -0.0025
        const TIGHTEST_ZOOM = 0.2
        const selection = App.game.chapter.selection
        const previousCameraZ = selection.camera.position.z
        let zoom = event.deltaY * ZOOM_RATE
        selection.camera.position.z -= zoom
        if(selection.camera.position.z < TIGHTEST_ZOOM) {
            selection.camera.position.z = TIGHTEST_ZOOM
            zoom = previousCameraZ - TIGHTEST_ZOOM
        }
        selection.camera.position.x += zoom * selection.pointer.position.x
        selection.camera.position.y += zoom * selection.pointer.position.y
    }
    // === Selection Functions === //
    get selectedScene() {
        return Dev.loadedScript?.scenes.find((scene) => scene.key == Dev.devSelection.selectedSceneKey)
    }
    get selectedSceneStep() {
        if(this.selectedScene == undefined) return
        function findStepInNestedEventsList(list) {
            let foundStep
            list.forEach((step) => {
                if(step.key == Dev.devSelection.selectedSceneStepKey) foundStep = step
                if(step.eventsList != undefined) foundStep = foundStep || findStepInNestedEventsList(step.eventsList)
            })
            return foundStep
        }
        return findStepInNestedEventsList(this.selectedScene.events.list)
    }
    clearSelected() {
        this.selectedSpotKey = undefined
        this.selectedEncounterKey = undefined
        this.selectedVertexKey = undefined
        this.multiselectedVertexKeys = []
        this.selectedSavestateReport = undefined
        this.selectedBlockKeys = undefined
    }
    // === Draw Functions === //
    addTileToBlock({position, tileTemplate}) {
        const blocks = Dev.loadedProtostage.world.blocks
        const key = position.x + "x" + position.y + "x" + (position.z - BLOCK_SIZE) + (tileTemplate.channelKey == undefined ? "" : "_" + tileTemplate.channelKey)
        const changedTile = {
            "position": {"x": position.x, "y": position.y, "z": position.z - BLOCK_SIZE},
            "size": {"x": 1, "y": 1, "z": BLOCK_SIZE},
            "tileKey": tileTemplate.key || 0,
            "channelKey": tileTemplate.channelKey,
            "colors": structuredClone(tileTemplate.gradientSwap || tileTemplate.defaultColors),
        }
        blocks[key] = changedTile
    }
    // === Erase Functions === //
    deleteSelection() {
        if(Dev.isEditingProto() == false) return
        if(Dev.mode == "battle") {
            this.deleteSelectedUnit()
            this.deleteSelectedSpot()
        }
        if(Dev.mode == "geography") {
            if(this.selectedEncounterKey != undefined) {
                Dev.saveToUndo()
                if(this.multiselectedVertexKeys.length > 0) {
                    const selectedEncounterVertices = Dev.loadedProtostage.world.encounters[this.selectedEncounterKey].points
                    const numberOfRemovedVertices = this.multiselectedVertexKeys.length
                    let highestSelectedVertexIndex = selectedEncounterVertices.findIndex((point) => point.key == this.selectedVertexKey)
                    for(const vertexKey of this.multiselectedVertexKeys) {
                        const index = selectedEncounterVertices.findIndex((point) => point.key == vertexKey)
                        if(index > highestSelectedVertexIndex) highestSelectedVertexIndex = index
                        selectedEncounterVertices.splice(index, 1)
                    }
                    this.multiselectedVertexKeys = []

                    const numberOfVertices = selectedEncounterVertices.length
                    if(numberOfVertices == 0) {
                        delete Dev.loadedProtostage.world.encounters[this.selectedEncounterKey]
                        this.selectedEncounterKey = undefined
                    } else {
                        this.selectedVertexKey = selectedEncounterVertices[(highestSelectedVertexIndex + 1 - numberOfRemovedVertices + numberOfVertices) % numberOfVertices].key
                    }
                } else if(this.selectedVertexKey != undefined) {
                    const selectedEncounterVertices = Dev.loadedProtostage.world.encounters[this.selectedEncounterKey].points
                    const selectedVertexIndex = selectedEncounterVertices.findIndex((point) => point.key == this.selectedVertexKey)
                    selectedEncounterVertices.splice(selectedVertexIndex, 1)

                    const numberOfVertices = selectedEncounterVertices.length
                    if(numberOfVertices == 0) {
                        delete Dev.loadedProtostage.world.encounters[this.selectedEncounterKey]
                        this.selectedEncounterKey = undefined
                    } else {
                        this.selectedVertexKey = selectedEncounterVertices[(selectedVertexIndex + numberOfVertices) % numberOfVertices].key
                    }
                } else {
                    delete Dev.loadedProtostage.world.encounters[this.selectedEncounterKey]
                    this.selectedEncounterKey = undefined
                }
            } else {
                const selection = App.game.chapter.selection
                const x = Math.ceil(selection.position.x)
                const y = Math.ceil(selection.position.y)
                const z = this.z

                const hoveredPositionalKeys = Object.keys(Dev.loadedProtostage.world.blocks).filter((key) => key.startsWith(x + "x" + y + "x" + z))
                const hoveredBlocks = hoveredPositionalKeys.map((key) => Dev.loadedProtostage.world.blocks[key]).filter((block) => {
                    return block.tileKey != undefined
                        && !(Dev.isRevealingSecretTiles == false && tileset[block.tileKey].isSecret == true)
                })
                hoveredBlocks.sort((a,b) => tileset[b.tileKey]?.drawOrder - tileset[a.tileKey]?.drawOrder)
                if(hoveredBlocks.length > 0) {
                    Dev.saveToUndo()
                    const hoveredBlock = hoveredBlocks.shift()
                    hoveredBlock.position.xyz = hoveredBlock.position.x + "x" + hoveredBlock.position.y + "x" + hoveredBlock.position.z

                    delete Dev.loadedProtostage.world.blocks[hoveredBlock.position.xyz + (hoveredBlock.channelKey != undefined ? "_" + hoveredBlock.channelKey : "")]
                    this.selectedBlockKeys = Object.keys(Dev.loadedProtostage.world.blocks).filter((key) => key.startsWith(hoveredBlock.position.xyz))
                    Dev.redrawWorld()
                }
            }
        }
    }
    deleteSelectedUnit() {
        const selection = App.game.chapter.selection
        const key = selection.selectedUnitKey || selection.hoveredUnitKey || this.listHoveredUnitKey
        if(key != undefined) {
            Dev.saveToUndo()
            if(Dev.isEditingProto() == true) {
                if(selection.multiselectedUnitKeys.length > 0) {
                    selection.multiselectedUnitKeys.forEach((anotherKey) => {
                        delete Dev.loadedProtostage.units[anotherKey]
                    })
                } else {
                    delete Dev.loadedProtostage.units[key]
                }
                Dev.autosaveUnitsToFile()
            } else {
                delete App.game.chapter.stage.units[key]
            }
            selection.hoveredUnitKey = undefined
            selection.selectedUnitKey = undefined
            selection.multiselectedUnitKeys = []
            App.game.chapter.recalculateStage()
        }
    }
    deleteSelectedSpot() {
        const selectedSpotKey = this.selectedSpotKey || this.hoveredSpotKey || this.listHoveredSpotKey
        if(selectedSpotKey == undefined) return
        Dev.saveToUndo()
        delete Dev.loadedProtostage.world.spots[selectedSpotKey]
        this.clearSelected()
    }
    // === Creation Functions === //
    placeNewUnit(position) {
        if(Dev.selectedTemplate == undefined) return
        const baseUnit = {
            "position": {
                "x": position.x,
                "y": position.y,
                "z": 1
            },
        }
        const newUnit = Objdict.merge(baseUnit,Dev.selectedTemplate)
        Dev.createNewUnit(newUnit)

        App.game.chapter.selection.selectedUnitKey = newUnit.key
        App.game.chapter.selection.clearSelected()
    }
}
